import React, { useState } from 'react';

const ShareButton = ({ title, text, url, className = '' }) => {
  const [sharing, setSharing] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareData = {
    title: title || 'Our Pickup',
    text: text || 'Join me on Our Pickup - local food, direct from farmers! 🚜🌱',
    url: url || window.location.href
  };

  const handleShare = async () => {
    setSharing(true);
    
    try {
      // Use Web Share API if available
      if (navigator.share) {
        await navigator.share(shareData);
        console.log('✅ Shared successfully');
        // Track share
        trackShare();
      } else {
        // Fallback: copy link to clipboard
        await fallbackShare();
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Share failed:', error);
        // Fallback: copy link
        await fallbackShare();
      }
    } finally {
      setSharing(false);
    }
  };

  const fallbackShare = async () => {
    try {
      await navigator.clipboard.writeText(shareData.url);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
      // Track share
      trackShare();
    } catch (error) {
      // Prompt with share text
      const shareText = `${shareData.text}\n\n${shareData.url}`;
      prompt('Copy this link to share:', shareText);
    }
  };

  const trackShare = async () => {
    try {
      await fetch('/api/pwa/share', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          platform: navigator.platform,
          userAgent: navigator.userAgent,
          url: shareData.url,
          timestamp: new Date().toISOString()
        })
      });
    } catch (error) {
      console.error('Error tracking share:', error);
    }
  };

  return (
    <button
      onClick={handleShare}
      disabled={sharing}
      className={`inline-flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 ${className}`}
    >
      {sharing ? (
        '⏳ Sharing...'
      ) : copied ? (
        '✅ Copied!'
      ) : (
        <>
          <span>📤</span> Share
        </>
      )}
    </button>
  );
};

export default ShareButton;
